import React from "react";
import HeroBanner from "./HeroBanner";
import "./Home.css";

const HomePage = () => {
  return (
    <main>
      <HeroBanner />
      

<div className="hzn-hero">
  {/* floating doodles (optional: swap srcs to your assets) */}
  <img className="hzn-heart hzn-heart--blue"  src="/assets/heart-blue.svg"  alt="" aria-hidden="true" />
  <img className="hzn-heart hzn-heart--green" src="/assets/heart-green.svg" alt="" aria-hidden="true" />
  <img className="hzn-heart hzn-heart--pink"  src="/assets/heart-pink.svg"  alt="" aria-hidden="true" />

  <div className="hzn-hero__inner">
    <h1 className="hzn-hero__title">
      Therapeutic Care, Support and<br/>
      SEND Education for Children &<br/>
      Young People
    </h1>

    <p className="hzn-hero__lead">
      We are a growing provider of children's homes, specialist education, and
      supported accommodation for children and young people across England.
    </p>

    <p className="hzn-hero__tag">Young Lives, Bright Futures.</p>

    <a href="/about" className="hzn-btn hzn-btn--green">About Us</a>
  </div>
</div>





<div className="cp-features">
  <div className="cp-features__grid">
    {/* Card 1 */}
    <div className="cp-card" data-no="01">
      <div className="cp-card__icon">
        <img src="/teamwork.png" alt="World-Class Instructors" />
      </div>
      <h3 className="cp-card__title">Experienced <br/>Staff</h3>
      <p className="cp-card__text">
        Trained in safeguarding <br/>and care.
      </p>
    </div>

    {/* Card 2 */}
    <div className="cp-card" data-no="02">
      <div className="cp-card__icon">
        <img src="/eco-house.png" alt="Online & Interactive Courses" />
      </div>
      <h3 className="cp-card__title">Safe & Supportive <br/>Environment</h3>
      <p className="cp-card__text">
        Promoting children’s  <br/>wellbeing every day.
      </p>
    </div>

    {/* Card 3 */}
    <div className="cp-card" data-no="03">
      <div className="cp-card__icon">
        <img src="/hands.png" alt="Career-Focused Programs" />
      </div>
      <h3 className="cp-card__title">Individualised <br/>Care Plans</h3>
      <p className="cp-card__text">
       Tailored support for <br/>every child’s needs.
      </p>
    </div>

    {/* Card 4 */}
    <div className="cp-card" data-no="04">
      <div className="cp-card__icon">
        <img src="/certificate.png" alt="Globally Relevant Qualifications" />
      </div>
      <h3 className="cp-card__title">Education & <br/>Development</h3>
      <p className="cp-card__text">
        Encouraging growth, learning, <br/>and independence.
      </p>
    </div>
  </div>
</div>



<div className="pay-section">
  {/* Top headline row */}
  <div className="pay-container pay-top">
    <h2 className="pay-title">
      Every Child Deserves <br/>
      <span className="pay-accent">A Safe Place to</span> <br/> Call Home
    </h2>

    <p className="pay-intro">
      Our mission is to create a stable, loving, and structured environment where every child feels safe, supported, and valued. 
      We provide the care and guidance children need to heal from past experiences, grow in confidence, and 
      develop the skills that will help them build brighter, more independent futures.
    </p>
  </div>

  {/* Feature card */}
  <div className="pay-container">
    <div className="pay-card">
      <div className="pay-card__content">
        <p className="pay-eyebrow">Helping Children Feel Part of the Wider Community</p>
        <h3 className="pay-card__title">Life at Careplus Homes</h3>
        <p className="pay-card__text">
          Our home is a warm, welcoming place where children feel safe, 
          respected, and encouraged. We provide structured routines, 
          healthy meals, and engaging activities designed to promote 
          wellbeing and positive development.
        </p>

        <a href="#get-started" className="pay-btn">
          Get Started <span className="pay-arrow" aria-hidden="true">→</span>
        </a>
      </div>

      <div className="pay-card__visual">
  {/* Replace with your single card image */}
  <img className="cc-img" src="/carey.jpg" alt="Care Home" />
</div>
    </div>
  </div>
</div>




    </main>
  );
};

export default HomePage;
